import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import classnames from 'classnames';
import { HardwareProductsTable } from '../../products/hardwareProducts/components';
import { SoftwareProducts } from '../../products/softwareProducts/components';
import ActionButton from '../../../components/ActionButton';

const optionToUrl = {
    addHardware: id => `/#/customer/${id}/hardwareproducts/addhardware`,
    orderSoftware: id => `/#/customer/${id}/order`,
    cancellation: id => `/#/customer/${id}/productcancelation`
};

let getButton = (option, id) => <a href='' />;

const statusesToHide = ['WriteOff', 'Cancelled'];
const isVisible = state => statusesToHide.indexOf(state) === -1;

const ProductBox = ({ hardwareProducts, softwareProducts, onOptionChosen, customerId }) => {
    const activeProducts = hardwareProducts.productsList.filter(item => isVisible(item.status));
    const activeSubscriptions = softwareProducts.productsList.filter(item => isVisible(item.status));

    return (
        <div className="">
            <div className='col-xs-12 col-sm-6 col-md-6 accentedText contentColumn separator'>
                <SoftwareProducts softwareProductsList={activeSubscriptions} />
            </div>
            <div className='col-xs-12 col-sm-6 col-md-6 accentedText contentColumn'>
                <HardwareProductsTable hardwareProductsList={activeProducts} className='hardwareTable' />
            </div>
        </div>
    );
};

const mapDispatchToProps = (dispatch, props) => ({
    onOptionChosen: (value, customerId) => dispatch(push(optionToUrl[value](customerId)))
});

export default connect(null,mapDispatchToProps)(ProductBox);
